export const FREE_LOCKED_REVENUE_TABS = new Set([
  "fixed_cost_viability",
  "product_sku_economics",
  "customer_lifetime_economics",
  "growth_efficiency_channel_mix",
  "margin_stability",
  "operations_readiness_confidence",
]);

export const collectionByKey = {
  benchmark: "shop_benchmark_report",
  market: "shop_market_analysis",
  market_v2: "shop_market_analysis_v2",
  competitor: "shop_competitor_analysis",
  ideation: "monthly_ideation",
  seo: "shop_seo_reports",
  adsAudit: "ads_audit",
  influencer: "influencer_discovery",
  meta: "shop_meta",
  google_search_console: "google_search_console",
  google_merchant_center: "google_merchant_center",
  revenue_reality: "revenue_reality_full_report",
  yearlyContent: "yearly_content_calendar",
  target_audience: "shop_target_audience",
  dailyOverview: "shop_daily_overview",
  conversion: "conversion_and_pdp_report",
  homepageAssessment: "homepage_assessment",
  socialMedia: "social_media_report",
  salesOrdersRolling: "sales_orders_rolling_report",
};

const COLLECTION_TITLES = {
  shop_daily_overview:          "Daily Overview",
  shop_meta:                    "Meta Ads Report",
  shop_benchmark_report:        "Shop Summary",
  shop_market_analysis:         "Shop Market Analysis",
  shop_market_analysis_v2:      "Shop Market Analysis V2",
  shop_competitor_analysis:     "Shop Competitor Analysis",
  monthly_ideation:             "Monthly Ideation Report",
  shop_seo_reports:             "Shop SEO Report",
  ads_audit:                    "Ads Audit Report",
  influencer_discovery:         "Influencer & Trending Report",
  google_search_console:        "Google Search Console",
  google_merchant_center:       "Google Merchant Center",
  revenue_reality_full_report:  "Revenue Reality Report",
  yearly_content_calendar:      "Monthly Events Calendar",
  shop_target_audience:         "Target Audience",
  historical_orders_data:       "Historical Orders Report",
  conversion_and_pdp_report:    "Conversion & PDP Analysis",
  homepage_assessment:          "Home Page Assessment",
  social_media_report:          "Social Media Report",
  sales_orders_rolling_report:  "Sales and Orders",
};

export const getReportTitle = (report, t) => {
  const collectionName = report?.data?.collection_name;
  return (
    COLLECTION_TITLES[collectionName] ||
    report?.name ||
    t("ReportsPage.reportDetails") ||
    "Report Details"
  );
};
